import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const BookIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M22 2h-6c-1.4 0-2.7.5-3.6 1.5L12 4l-.4-.5A5 5 0 0 0 8 2H2a1 1 0 0 0-1 1v15c0 .5.4 1 1 1h7a2 2 0 0 1 2 2c0 .5.5 1 1 1s1-.5 1-1a2 2 0 0 1 2-2h7c.5 0 1-.5 1-1V3c0-.5-.4-1-1-1ZM11 17.6c-.6-.4-1.3-.6-2-.6H3V4h5c.8 0 1.6.3 2.1.9.6.6 1 1.3 1 2v10.7Zm10-.6h-6c-.7 0-1.4.3-2 .6V7c0-.8.3-1.5.9-2a3 3 0 0 1 2-1H21v13Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default BookIcon;
